import type { TextUIPart } from 'ai'
import { LlmChatMarkdownContent } from './LlmChatMarkdownContent'

export type LlmChatAssistantTextPartProps = {
  part: TextUIPart
  showTextCursor: boolean
  isLastTextPart: boolean
  onOpenCitationLink?: (input: {
    href: string
    label: string
  }) => boolean | Promise<boolean>
}

export function LlmChatAssistantTextPart({
  part,
  showTextCursor,
  isLastTextPart,
  onOpenCitationLink,
}: LlmChatAssistantTextPartProps) {
  return (
    <div className='wrap-break-word'>
      <LlmChatMarkdownContent
        text={part.text}
        onOpenCitationLink={onOpenCitationLink}
      />
      {showTextCursor && isLastTextPart ? (
        <span
          className='ms-0.5 inline-block h-3 w-1.5 translate-y-px animate-pulse rounded-sm bg-primary/80 align-middle'
          aria-hidden
        />
      ) : null}
    </div>
  )
}
